import { GenericDialog } from "@/components/dialogs";
import { TestEventPrintOptions } from "@/api/williams/report";
import { useState } from "react";

export type PrintDialogProps = {
  onAccept: (options: TestEventPrintOptions) => void;
};

export function PrintDialog({ onAccept }: PrintDialogProps) {
  const [options, setOptions] = useState<TestEventPrintOptions>({
    summary: true,
    results: false,
  });

  function handleSelectionChanged(e: React.ChangeEvent<HTMLInputElement>) {
    setOptions((prev) => ({
      ...prev,
      [e.target.id]: e.target.checked,
    }));
  }

  return (
    <GenericDialog
      caption="Select items to print"
      buttons="OKCancel"
      onAccept={() => onAccept(options)}
      allowAccept={Object.entries(options).some(([, value]) => value)}
    >
      <div className="form-check">
        <input
          type="checkbox"
          className="form-check-input"
          id="summary"
          checked={options.summary}
          onChange={handleSelectionChanged}
        />
        <label className="form-check-label" htmlFor="summary">
          Summary
        </label>
      </div>
      <div className="form-check">
        <input
          type="checkbox"
          className="form-check-input"
          id="results"
          checked={options.results}
          onChange={handleSelectionChanged}
        />
        <label className="form-check-label" htmlFor="results">
          Test Results
        </label>
      </div>
    </GenericDialog>
  );
}
